( function () {
   
    'use strict';

    ( function ( $ ) {
        $('.news-latest-one').slick({
            dots:false,
            infinite: true,
            speed: 600,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay:false,
            autoplaySpeed: 1500,
            arrows:true,
            variableWidth: true,
            responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow:3,
                    slidesToScroll:1,
                    infinite: true,
                }
            },
            {
                breakpoint:767,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                    centerPadding: '20px',
                    centerMode: true,
                }
            }
            ]
        });
        $('.news-latest-one.rtl').slick({
            dots:false,
            infinite: true,
            speed: 600,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay:false,
            autoplaySpeed: 1500,
            arrows:true,
            rtl: true,
            variableWidth: true,
            responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow:3,
                    slidesToScroll:1,
                    infinite: true,
                }
            },
            {
                breakpoint:767,
                settings: {
                    slidesToShow:1,
                    slidesToScroll:1,
                    centerPadding: '20px',
                    centerMode: true,
                }
            }
            ]
        });
       
        // if($('.video-overlay-content').length > 0){
                  
           
         
        // }
      
      
        
    } )( jQuery );
} )();

